import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=31f07349&scoped=true"
import script from "./MasterPage.vue?vue&type=script&lang=js"
export * from "./MasterPage.vue?vue&type=script&lang=js"
import style0 from "./MasterPage.vue?vue&type=style&index=0&id=31f07349&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f07349",
  null
  
)

export default component.exports